import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import "./SupplierImport.scss";

import {
  Button,
  Table,
  Form,
  Badge,
  Modal,
  Breadcrumb,
  OverlayTrigger,
} from "react-bootstrap";
import {
  BsQuestionCircle,
  BsCheck,
  BsExclamationTriangleFill,
  BsExclamationCircleFill,
  BsDownload,
  BsFillCheckCircleFill,
} from "react-icons/bs";
import { BiSearch, BiShareAlt, BiTrash, BiChevronRight } from "react-icons/bi";
import { CgSortAz } from "react-icons/cg";

function ImportCompleted({ t, callbackCompleted }) {
    const handleNewImport = () => {
        let obj = {
            type: "Back"
        };
        callbackCompleted(obj);
    }
  const navigate = useNavigate();
  return (
    <div className="Import_SuccessfullyCard">
      <div className="Import_SuccessfullyCard_head">
        <h6>
          <BsFillCheckCircleFill /> Completed Import Successfully
        </h6>
        <p className="m-0">
          Your data has been successfully imported. Now you can find it in the
          supplier list.
        </p>
      </div>
      <div className="py-2">
        <Button
          variant="secondary"
          className="btn px-4 me-3"
          onClick={handleNewImport}
        >
          <BsDownload className="me-1" /> Import another file
        </Button>
        
        <Link to="/company_admin/list_supplier">
          <Button variant="primary" className="btn px-4">
            {t("GotoSuppliersList.label")}
          </Button>
        </Link>
      </div>
    </div>
  );
}
export default withTranslation()(ImportCompleted);
